import { render } from "./BaseBadge.vue?vue&type=template&id=76be1e55&scoped=true&ts=true"
import script from "./BaseBadge.vue?vue&type=script&lang=ts"
export * from "./BaseBadge.vue?vue&type=script&lang=ts"

import "./BaseBadge.vue?vue&type=style&index=0&id=76be1e55&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76be1e55"]])

export default __exports__